import { initializeFirebase } from '@mizz/penny-firebase'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import store from './store'
import Vuent from 'vuent'
import 'vuent/dist/vuent.min.css'

initializeFirebase()

Vue.use(Vuent)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
